import { FC } from 'react';
import TimeCostTable from './sharedComponents/table/table.component';
import LiquidationTimeCostChart from './sharedComponents/chart/chart.component';
import { clientNameSelector } from '../../../../redux/auth/selectors';
import { useSelector } from 'react-redux';
import WcapitalCustomGraphs from './sharedComponents/subComponents/WcapitalCustomGraphs.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useRstVariablePageModel } from '../../../../api/rs-hg/liquidity/hooks/queries';
import { RstVariableReport } from './rstVariable.types';

const RstVariable: FC<FundInfoComponentProps> = (props) => {
  const activeFund = props.fundId;
  const activeDate = props.positionDate;
  const { section } = props;

  const clientName = useSelector(clientNameSelector);
  const variableDataQuery = useRstVariablePageModel(activeFund, activeDate);

  return (
    <QueryBoundary<RstVariableReport>
      isLoading={variableDataQuery.isLoading}
      isFetching={variableDataQuery.isFetching}
      isError={variableDataQuery.isError}
      error={variableDataQuery.error}
      data={variableDataQuery.data?.data}
      loadingMessages={['Loading variable reverse stress test data...']}
      noDataMessage="No Data Available."
      errorMessage="No Data Available."
    >
      {(report) => (
        <>
          {clientName === 'wcapital' ? (
            <WcapitalCustomGraphs
              section={section}
              timeCostData={report}
              isFetching={variableDataQuery.isFetching}
              error={variableDataQuery.error}
            />
          ) : (
            <>
              <TimeCostTable
                section={section}
                bauOrStressed="bau"
                timeCostData={report}
                isFetching={variableDataQuery.isFetching}
              />
              <TimeCostTable
                section={section}
                bauOrStressed="stressed"
                timeCostData={report}
                isFetching={variableDataQuery.isFetching}
              />
            </>
          )}
          <LiquidationTimeCostChart
            bauOrStressed="bau"
            liquidationData={report}
            isFetching={variableDataQuery.isFetching}
            error={variableDataQuery.error}
            pdfDontmoveToNewPage={true}
            pdfAligment={'left'}
            pdfDontIncrementYPosition={true}
          />
          <LiquidationTimeCostChart
            bauOrStressed="stressed"
            liquidationData={report}
            isFetching={variableDataQuery.isFetching}
            error={variableDataQuery.error}
            pdfDontmoveToNewPage={true}
            pdfAligment={'right'}
          />
        </>
      )}
    </QueryBoundary>
  );
};

export default RstVariable;
